import { useEffect } from "react";
import { handleFirstInteraction } from "../utils/function";
const EVENTS_LIST = ["click", "keydown", "touchstart", "keyup"];

export const useFullscreen = (onFullscreen) => {
  useEffect(() => {
    EVENTS_LIST.forEach((event) => {
      document.addEventListener(event, handleFirstInteraction);
    });
    return () => {
      EVENTS_LIST.forEach((event) => {
        document.removeEventListener(event, handleFirstInteraction);
      });
    };
  }, [onFullscreen]);
};
